import WebUniversal, { initDataType, WUExtendPropsType } from '../WebUniversalNewEx'
import { columnsheadId, showText } from '../../universal/columnshead';
import dayjs from 'dayjs';
import { Button, DatePicker, Select, Space, Tooltip } from 'antd';
import LoggerClear from './LoggerClear';
import { useEffect, useRef, useState } from 'react';
import getList from '../../universal/getList';
import { createDeclareType, createTypeFactory } from '../../../utilsTs/declareTypes';
import fetchApi from '../../../utils/api/fetchApi';
import systematic from '../../../config/systematic';

/** 日志对象 */
export const Logs = createTypeFactory({
    /** 操作日志 */
    opLogger: { id: 'opLogger', name: '操作日志' },
    /** 系统日志 */
    systemLogger: { id: 'systemLogger', name: '系统日志' },
    /** 登录日志 */
    loginLogger: { id: 'loginLogger', name: '登录日志' },
    /** 菜谱操作日志 */
    menuOpLogger: { id: 'menuOpLogger', name: '菜谱操作日志' },
    /** 菜单操作日志 */
    reserveMenuOpLogger: { id: 'reserveMenuOpLogger', name: '菜单操作日志' },
    /** 时段操作日志 */
    salePeriodOpLogger: { id: 'salePeriodOpLogger', name: '时段操作日志' },
    /** 主配料操作日志 */
    ingredientOpLogger: { id: 'ingredientOpLogger', name: '主配料操作日志' },
    /** 仓库日志 */
    warehouseLogger: { id: 'warehouseLogger', name: '仓库日志' }
} as const);

/** 日志类型 */
export declare type loggerType = createDeclareType<typeof Logs>;

/**
 * 日志
 * @param props 
 * @param options 选项
 * @returns 
 */
const Logger = (props: any) => {
    /** 日志类型 */
    const { data = {} } = props;
    const ref = useRef<any>(undefined);
    let { isQuery, queryType, queryTypeExtendId, queryId, isScope, logger,
        isShowloggerClear, isLockLoggerTypeSelect, isLockLoggerDateSelect } = data;
    const [dateTime, setDateTime] = useState<any>();
    const [loggerTypeSelectDisabled, setLoggerTypeSelectDisabled] = useState(false);
    const [loggerDateSelectDisabled, setLoggerDateSelectDisabled] = useState(false);
    const [logsLevelData, setLogsLevelData] = useState<any>([]);
    let defaultService: any = systematic.wmService;

    /** apiId */
    const apiId = 'logger';
    /** 日志id */
    const [loggerId, setLoggerId] = useState<string>('systemLogger');
    const [logsLevel, setLogsLevel] = useState<number>(-1)
    const [loggerTypeData, setLoggerTypeData] = useState<any>();
    if (typeof isQuery === 'undefined') {
        isQuery = true;
    }
    if (typeof isShowloggerClear === 'undefined') {
        isShowloggerClear = true;
    }
    const [modalVisibleLoggerClear, setModalVisibleLoggerClear] = useState(false);
    const loggerClearVisible = (visible: boolean) => {
        setModalVisibleLoggerClear(visible);
    }

    useEffect(() => {
        setLoggerTypeData(Logs.getAll());
        if (logger) {
            handleSelectLoggerType(logger.id);
            if (isLockLoggerTypeSelect === true) {
                setLoggerTypeSelectDisabled(true);
            }
            if (isLockLoggerDateSelect === true) {
                setLoggerDateSelectDisabled(true);
            }
        }
        else {
            handleSelectLoggerType(loggerId);
        }
        fetchApi.GET(defaultService,
            {
                apiId: 'generalData',
                apiVariable: 'logsLevel',
                apiExtend: 'showLists'
            }
        ).then((res) => {
            const { logsLevel } = res.data;
            setLogsLevelData(logsLevel)
        }).catch((err) => {
            console.log(err);

        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //表头
    const columnsHead = [
        {
            title: '时间',
            dataIndex: 'createdAt',
            render: (val: any) =>
                <span>
                    {dayjs(val).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
            sorter: true,
        },
        {
            title: '级别',
            dataIndex: 'logsLevel_Name',
            sorter: true,
            render: (text: any, record: any) => {
                let showText;
                switch (record.logsLevelId) {
                    case 0:
                        showText = (<span style={{ color: 'red' }}>{text}</span>);
                        break;
                    case 1:
                        showText = (<span style={{ color: 'yellow' }}>{text}</span>);
                        break;
                    case 2:
                        showText = (<span style={{ color: 'green' }}>{text}</span>);
                        break;
                    case 4:
                        showText = (<span style={{ color: 'blue' }}>{text}</span>);
                        break;
                    default:
                        <>{text}</>
                        break;
                }
                return showText;
            }
        },
        {
            title: '来源',
            dataIndex: 'scope',
            sorter: true,
            render: (text: any) => {
                return showText(text, 15, 'suffix');
            }
        },
        {
            title: '信息',
            dataIndex: 'info',
            sorter: true,
            render: (text: any) => {
                return showText(text, 20);
            }
        },
        {
            title: '详情',
            dataIndex: 'details',
            render: (text: any) => {
                return showText(text, 20);
            }
        },
        {
            title: '代码',
            dataIndex: 'errorCodeId',
        },
        {
            title: '设备',
            dataIndex: 'device',
            render: (text: any) => <Tooltip placement="topLeft" title={text ? text.deviceName : ''}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.deviceName.length >= 10 ? text.deviceName.substring(0, 10) + '......' : text.deviceName)
                    : ''
            }</Tooltip>
        },
        {
            title: '操作人',
            dataIndex: 'userName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? text.substring(0, 10) + '......' : text)
                    : ''
            }</Tooltip>
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '日志',
        apiId,
        columns,
        sendPageData: { loggerId, logsLevel,queryType, queryTypeExtendId, queryId, isScope, dateTime },
        showOperation: !isQuery,
        showAdd: false,
        showEdit: false,
        showQuery: isQuery,
        pagination: true,
        isInitialDisplayData: false,
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    /**
     * 刷新数据
     * @param options 选项
     */
    const refreshData = (options: {
        currentLoggerId?: string,
        currentSendPageData?: any,
        currentLogsLevel?:number
    }) => {
        let { currentLoggerId, currentSendPageData,currentLogsLevel } = options;
        currentSendPageData = typeof currentSendPageData !== 'undefined' ? currentSendPageData : { loggerId, queryType, queryTypeExtendId, queryId, isScope, dateTime }
        if (typeof currentLoggerId !== 'undefined') {
            currentSendPageData = {
                ...currentSendPageData,
                loggerId: currentLoggerId,
                logsLevel:currentLogsLevel
            }
        }
        const currentData: initDataType = {
            apiId,
            sendPageData: currentSendPageData
        }
        ref.current.initData(currentData);
    };

    /**
     * 选项日志类型
     * @param e 
     */
    const handleSelectLoggerType = (e: any) => {
        refreshData({
            currentLoggerId: e,
            currentLogsLevel:logsLevel,
        })
        setLoggerId(e);
    };

       /**
     * 选项日志级别
     * @param e 
     */
    const handleSelectLogsLevel = (e: any) => {
        refreshData({
            currentLoggerId: loggerId,
            currentLogsLevel:e,
        })
        setLogsLevel(e);
    };

    /**
     * 根据日期回显数据
     * @param e 
     */
    const handleDate = (e: any) => {
        let orderDateEx;
        if (e) {
            orderDateEx = dayjs(e).format("YYYY-MM-DD")
            setDateTime(orderDateEx)
        } else {
            setDateTime(null)
        }
        refreshData({
            currentSendPageData: { loggerId, logsLevel, queryType, queryTypeExtendId, queryId, isScope, dateTime: orderDateEx }
        })
    };

    return (
        <>
            <Space>
                <Select
                    showSearch
                    placeholder="日志类型"
                    optionFilterProp="children"
                    defaultValue={'systemLogger'}
                    onChange={handleSelectLoggerType}
                    disabled={loggerTypeSelectDisabled}
                    value={loggerId}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.generalEx(loggerTypeData)}
                </Select>
                <Select
                    showSearch
                    placeholder="日志级别"
                    optionFilterProp="children"
                    onChange={handleSelectLogsLevel}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.generalEx(logsLevelData)}
                </Select>
                <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={loggerDateSelectDisabled}
                    onChange={handleDate} />
                {isShowloggerClear === true ? <Button onClick={() => loggerClearVisible(true)}>清除日志</Button> : null}
            </Space>
            <WebUniversal ref={ref} props={extendProps} />
            {modalVisibleLoggerClear ? (<LoggerClear apiId={apiId} onClose={loggerClearVisible} />) : null}

        </>
    )
}

export default Logger;


